import { UserGroup, UserGroupFromJSON } from "../Users/UserGroup";
import {
  SprintUserCommitment,
  SprintUserCommitmentFromJSON,
} from "./SprintUserCommitment";

export interface SprintUser {
  sprintId: number;
  userId: number;
  userLogin: string;
  userDisplayName: string;
  userSprintAvailability: number;
  userSprintCommitment: SprintUserCommitment;
  userSprintSpentTime: number;
  groups: Array<UserGroup>;
}

export function SprintUserFromJSON(json: Record<string, any>): SprintUser {
  return {
    sprintId: json["sprintId"],
    userId: json["userId"],
    userLogin: json["userLogin"],
    userDisplayName: json["userDisplayName"],
    userSprintAvailability: json["userSprintAvailability"],
    userSprintCommitment: SprintUserCommitmentFromJSON(
      json["userSprintCommitment"] || {},
    ),
    userSprintSpentTime: json["userSprintSpentTime"],
    groups: (json["groups"] || []).map(UserGroupFromJSON),
  };
}
